import styled from 'styled-components';

export const LabelContent = styled.div`
  color: ${({ theme }) => theme.franco.colors.white};
  display: flex;
  align-items: center;
`;
